const Roles = {
  panel_user: 'ed85a1c1d086',
  panel_moderator: 'f027b569cb4d',
  dashboard_user: '08fbfc639357',
  reviewer: 'ad78cbd60e8b',
  operator: '39a490e9fd1a',
  admin: '951092525e00',
  dashboard_viewer: 'af0a034a5ca5',
};

export const encryptRole = (decryptedRole) => Roles[decryptedRole];
export const decryptRole = (encryptedRole) => {
  const role = Object.entries(Roles).find(([, enc]) => enc === encryptedRole);
  if (!role || !role.length) {
    return null;
  }
  return role[0];
};
